import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { useSEO } from "@/lib/seo";

const PrivacyPage = () => {
  const seo = useSEO(
    "Privacy Policy",
    "How ClearSlot handles and protects partner and guest data.",
    "https://clearslot.io/privacy",
  );
  return (
    <div className="min-h-screen bg-background">
      {seo}

      <Navbar />

      <main className="container max-w-3xl mx-auto px-6 py-24 pt-32">
        <p className="text-sm text-muted-foreground mb-2">Last updated: April 2026</p>
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-10">Privacy Policy</h1>

        <div className="space-y-10 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">1. Who we are</h2>
            <p>
              ClearSlot (clearslot.io) is a neutral booking coordination infrastructure provider based in Denmark.
              We operate as a data processor on behalf of partner platforms.
            </p>
            <p className="mt-3">
              For data protection inquiries or to contact our Data Protection Officer:{" "}
              <a href="mailto:privacy@clearslot.io" className="text-foreground underline hover:text-primary">privacy@clearslot.io</a>.
              We aim to respond within 72 hours.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">2. What data we collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Account data: name, email address, business name</li>
              <li>Booking coordination data: availability signals, booking outcomes (not content)</li>
              <li>Guest behaviour signals: anonymised patterns submitted by partner platforms</li>
              <li>Technical data: IP address, browser type, session identifiers, cookies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">3. Why we collect it</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To operate the ClearSlot Partner Hub</li>
              <li>To coordinate booking availability across platforms</li>
              <li>To surface guest reputation signals to partner platforms</li>
              <li>To improve service reliability and detect misuse</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">4. Legal basis (GDPR Article 6)</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Contract performance (Art. 6.1.b) for account and booking data</li>
              <li>Legitimate interests (Art. 6.1.f) for analytics and fraud prevention</li>
              <li>Consent (Art. 6.1.a) for non-essential cookies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">5. Data sharing</h2>
            <p className="mb-3">We do not sell personal data. Data may be shared:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>With partner platforms you are connected to via ClearSlot</li>
              <li>With infrastructure providers (Supabase, Railway) under GDPR-compliant agreements</li>
              <li>With authorities if legally required</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">6. Data retention</h2>
            <p>
              Account data is retained for the duration of the contract + 12 months. Guest behaviour signals
              are retained for 24 months. Anonymised aggregated data may be retained indefinitely.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">7. Your rights (GDPR)</h2>
            <p>
              As a data subject you have the right to: access, rectification, erasure ("right to be forgotten"),
              restriction of processing, data portability, and to object. To exercise any right, email{" "}
              <a href="mailto:privacy@clearslot.io" className="text-foreground underline hover:text-primary">privacy@clearslot.io</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">8. Cookies</h2>
            <p>
              We use essential cookies (required for the service) and optional analytics cookies. You can manage
              your preference via the cookie banner or browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">9. Contact</h2>
            <p>
              Data controller: ClearSlot ·{" "}
              <a href="mailto:privacy@clearslot.io" className="text-foreground underline hover:text-primary">privacy@clearslot.io</a>
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
